export enum FinanceBalanceType {
  RegularPayment = 'REGULAR_PAYMENT',
  MajorRenovation = 'MAJOR_RENOVATION',
  All = 'ALL'
}

export enum FinanceBalanceState {
  AllPaid = 'ALL_PAID',
  NotPaid = 'NOT_PAID',
  NoInvoices = 'NO_INVOICES'
}

export type FinanceBalanceTicketDomainType = {
  title: string
  debtSum: number
  canPay: boolean
  dueDate: string | null
  state: FinanceBalanceState
  merchId: string
}

export type FinanceBalanceTicketType = {
  name: string
  debtSum: number
  canPay: boolean
  payBefore: string | null
  type: FinanceBalanceType
  state: FinanceBalanceState
  merchId: string
}

export type FinanceBalance = {
  totalSum: number
  tickets: FinanceBalanceTicketType[]
}
